import BaseService from "./BaseService"

class FavouritesService extends BaseService {

}

export default new FavouritesService('health_backend', 'health/favourites')